import React, { useState } from 'react';
import './DeviceFeature.css';
import { Container } from 'react-bootstrap';
import {Title} from '../../../../Components'
import DeviceImage from '../../../../assets/Images/home/device-image.png';


const DeviceFeature = ({url, section}) => {

  const { device_image } = section.data;

  return (
    <div className="device-feature">
      <Container>
        <Title title={"Device Feature"} overlay={"Devices"} />
        <div className='device-feature-img'>
        <img src= {device_image? url +"/"+ device_image : DeviceImage}  />

      </div>
      </Container>
    
    </div>
  );
};

export default DeviceFeature;
